var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2260 4785 c-516 -72 -976 -308 -1329 -681 -310 -328 -502 -713 -587 -1179 -27 -144 -27 -586 0 -730 85 -466 277 -851 587 -1179 335 -354 760 -580 1264 -672 144 -27 586 -27 730 0 466 85 852 277 1179 587 355 336 580 759 672 1264 27 144 27 586 0 730 -29 158 -72 317 -121 442 -303 774 -982 1308 -1805 1419 -131 17 -461 17 -590 -1z m570 -331 c841 -122 1502 -783 1625 -1625 20 -138 20 -400 0 -538 -109 -747 -652 -1368 -1375 -1572 -331 -93 -693 -95 -1025 -4 -591 162 -1070 602 -1291 1185 -75 196 -114 424 -114 660 0 426 124 802 378 1144 414 558 1115 850 1802 750z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2045 3780 c-95 -21 -149 -110 -125 -202 10 -38 67 -98 482 -515 421 -422 471 -475 471 -503 0 -28 -49 -81 -466 -498 -256 -257 -471 -480 -476 -495 -29 -76 3 -174 69 -208 42 -23 120 -25 158 -5 15 8 243 232 508 498 418 420 484 490 503 537 49 117 48 236 -4 349 -23 49 -91 123 -503 535 -262 263 -488 484 -502 491 -35 18 -80 24 -115 16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.5690a75c6c4e22145fcad8ede4199b6b.svg";
export { ForwardRef as ReactComponent };